import React from 'react';
import { Link } from 'react-router-dom';

interface IMenuButtonProps {
  text: string;
  onClick: () => void;
  to: string;
  Icon: React.ComponentType<any>;
}

export const MenuButton = ({ onClick, text, to, Icon }: IMenuButtonProps) => {
  const isCurrentPage = window.location.pathname === to;
  const textStyles = isCurrentPage ? 'text-blue-600' : 'text-base-black text-space text-[16px] text-medium';
  const baseStyles = `${textStyles} w-full flex items-center flex-row gap-[6px] hover:text-blue-500 active:text-blue-700`;

  if (to === '') {
    return (
      <button type="button" onClick={onClick} className={baseStyles}>
        <Icon /> <span>{text}</span>
      </button>
    );
  }

  return (
    <Link to={to} onClick={onClick} className={baseStyles}>
      <Icon /> <span>{text}</span>
    </Link>
  );
};
